<input 
type="text" 
onkeypress='return event.charCode >= 48 && event.charCode <= 57'
[class]="class" 
[class.is-invalid]="control.touched && control.invalid"
[class.is-valid]="control.value && control.valid && showIconSuccess === true"
[class.is-loading]="control.pending && showIconSuccess === true"
[id]="id"
[name]="id"
[title]="title" 
[maxlength]="maxlength"
[placeholder]="placeholder" 
[formControl]="control" />
